// Misc functions
const { $, feather } = window;

$(() => {
  $('[data-toggle="collapse"]').on('click', function callback() {
    const $this = $(this);
    const $svg = $this.find('svg.feather').first();

    setTimeout(() => {
      if ($svg.hasClass('feather-chevron-down')) {
        $svg.parent().html(feather.icons['chevron-up'].toSvg());
      } else if ($svg.hasClass('feather-chevron-up')) {
        $svg.parent().html(feather.icons['chevron-down'].toSvg());
      }
    }, 100);
  });
});
